import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ClientService } from '@core/services/client/client.service';
import {
  IpFiltering,
  IpFilteringEditErrorMessage,
} from '@core/services/ip-filtering/ip-filtering.model';
import { IpFilteringService } from '@core/services/ip-filtering/ip-filtering.service';
import { process } from '@progress/kendo-data-query';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { IpFilteringEditComponent } from './component/ip-filtering-edit/ip-filtering-edit.component';
import { DescriptionModel } from '@core/services/base.model';

@Component({
  selector: 'Teranet-IpFiltering',
  templateUrl: './ip-filtering.component.html',
})
export class IpFilteringComponent implements OnInit {
  public gridSettings: GridSettings;
  public ipFilterings: IpFiltering[] = [];
  clientInfos: DescriptionModel[] = [];
  ipFilteringForm: FormGroup;
  ipFilteringEditErrorMessage = IpFilteringEditErrorMessage;
  services: any;

  constructor(
    public dialog: MatDialog,
    private ipFilteringService: IpFilteringService,
    private spinner: NgxSpinnerService,
    private clientService: ClientService
  ) {
    this.ipFilteringForm = new FormGroup({
      clientInfoId: new FormControl('', Validators.required),
    });

    this.ipFilteringService.isDataChanged$.subscribe(data => {
      if (data) {
        this.onSearch();
      }
    });
  }

  public state: any = {
    skip: 0,
    take: 13,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  ngOnInit(): void {
    this.gridSettings = this.GridDefaultSettings();
    this.getData();
  }

  getData() {
    const getClientInfos = this.clientService.getClientInfoDescriptions();
    getClientInfos.subscribe(data => {
      this.clientInfos = data as DescriptionModel[];
    });
  }

  onClearCriteria() {
    this.ipFilterings = [];
    const clientInfoId = this.ipFilteringForm.get('clientInfoId');
    clientInfoId.clearValidators();
    clientInfoId.updateValueAndValidity({ emitEvent: false });
    clientInfoId.setValue('');
  }

  onClientChange() {
    this.ipFilterings = [];
  }

  onDelete(row: any, services: any) {
    let dialog =
      this.services && this.services[0] ? this.services[0] : this != null ? this.dialog : null;
    let ipFilteringService =
      this.services && this.services[1]
        ? this.services[1]
        : this != null
        ? this.ipFilteringService
        : null;
    const dialogRef = dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: { message: 'Do you want to delete the IP Filter ' + row.ipFilterName + '?' },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        row.isDeleted = true;
        ipFilteringService.createOrUpdateOrDeleteIpFiltering(row, 0).subscribe(result => {
          let cur = result;
          ipFilteringService.setDataChanged(true);
          ipFilteringService.setDataChanged(false);
        });
      }
    });
  }

  onEdit(row: any, services: any) {
    let dialog =
      this.services && this.services[0] ? this.services[0] : this != null ? this.dialog : null;
    let ipFilteringService =
      this.services && this.services[1]
        ? this.services[1]
        : this != null
        ? this.ipFilteringService
        : null;

    if (row.constructor.name === 'Array' && this != null) {
      // This is "Add New"
      const clientInfoId = this.ipFilteringForm.get('clientInfoId');
      clientInfoId.clearValidators();
      clientInfoId.updateValueAndValidity({ emitEvent: false });
    }

    const dialogRef = dialog.open(IpFilteringEditComponent, {
      width: '800px',
      data: { row },
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        let test = result;
        ipFilteringService.setDataChanged(true);
        ipFilteringService.setDataChanged(false);
      }, 100);
    });
  }

  onSearch() {
    const clientInfoId = this.ipFilteringForm.get('clientInfoId');
    clientInfoId.setValidators([Validators.required]);
    clientInfoId.updateValueAndValidity({ emitEvent: false });

    if (this.ipFilteringForm.valid) {
      this.spinner.show();
      const getIpFilterings = this.ipFilteringService.getIpFilterings(clientInfoId.value);
      getIpFilterings.subscribe(data => {
        this.ipFilterings = data as IpFiltering[];
        this.gridSettings.gridData = { data: this.ipFilterings, total: this.ipFilterings.length };
        this.spinner.hide();
      });
    }
  }

  GridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.ipFilterings, this.state),
      columnsConfig: [
        {
          field: 'ipFilterName',
          filterable: true,
          hidden: false,
          title: 'Filter Name',
          width: 150,
        },
        {
          field: 'ipFilterStart',
          filterable: true,
          hidden: false,
          title: 'Filter From',
          width: 150,
        },
        {
          field: 'ipFilterEnd',
          filterable: true,
          hidden: false,
          title: 'Filter To',
          width: 150,
        },
        {
          field: 'isActive',
          filter: 'boolean',
          filterable: true,
          hidden: false,
          title: 'Is Active',
          type: 'boolean1',
          width: 80,
        },
        {
          clickAction: this.onEdit,
          excludeFromExcel: true,
          field: 'id',
          filterable: false,          
          hidden: false,
          icon: 'pen',
          includeInChooser: false,
          title: 'Edit',
          type: 'icon',
          services: [this.dialog, this.ipFilteringService],
          width: 40,
        },
        {
          clickAction: this.onDelete,
          excludeFromExcel: true,
          field: 'id',
          filterable: false,          
          hidden: false,
          icon: 'trash-alt',
          includeInChooser: false,
          title: 'Delete',
          type: 'icon',
          services: [this.dialog, this.ipFilteringService],
          width: 40,
        },
      ],
    };
  }
}
